import { SEO } from "./seo";

export type PageType = "SPARTAN" | "BOOK";

export class WebPage {
    id?: any;
    titleMenu?: any;
    title?: any;
    subtitle?: any;
    image?: any;
    description?: any;
    externalLink?: any;
    price?: any;
    discountPercentage?: any;
    jsonContent?: any;
    isValid?: boolean;
    pageType?: PageType;
    idSeoFk?: any;

    seo?: SEO;
}